import useDevTools from '../hooks/useDevTools';
import styles from './Back.module.scss';

const Back = ({ title, index = 0 }) => {
  const { back, menu } = useDevTools();

  return (
    <div className={styles.back}>
      {index < menu.length - 1 && (
        <button
          onClick={() => {
            back(index + 1);
          }}
        ></button>
      )}

      {title && <div className={styles.title}>{title}</div>}
    </div>
  );
};

export default Back;
